// Port of api/fuel/app/classes/controller/api/monty/users/avatar.php
import DB from 'offline/db'
export default function(params) {
	var slug = params.slug || params.name
	var rows = slug ? DB.query('SELECT user_avatar FROM user WHERE user_name = ?', [slug]) : []
	return Promise.resolve({ session: { offline: true }, data: { avatar: rows.length ? rows[0].user_avatar : '' } })
}
